import {FC} from 'react'
import {useParams} from 'react-router-dom'
import {useQuery} from 'hooks/graphql'
import {Presenter} from './Presenter'
import {PROCEDURE_STATUS, QueryVariables, QueryResult} from './query'

export const Update: FC = () => {
  const {id} = useParams<{id: string}>()
  const {data, loading} = useQuery<QueryResult, QueryVariables>(PROCEDURE_STATUS, {variables: {id}})

  return !loading && data ? (
    <Presenter employee={data.client.procedureStatus.employee} procedureStatus={data.client.procedureStatus} />
  ) : (
    <></>
  )
}
